<div class="main-content">
    <network-list></network-list>
</div>
